import React, { useState } from 'react';
import { useUpdateEffect } from 'react-use';
import {
  Card,
  CardContent,
  Grid,
  Input,
  Slider,
  Stack,
  Typography,
} from '@mui/material';
import VolumeDown from '@mui/icons-material/VolumeDown';

const SliderInputForm = (props) => {
  const {
    step = 1,
    min = 0,
    max = 0,
    onChange,
    defaultValue,
    init,
    readOnly,
  } = props;

  const [value, setValue] = useState(defaultValue || 0);

  const handleMouseUp = () => {
    onChange(value);
  };
  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    if (readOnly) return;
    setValue(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
      onChange(0);
    } else if (value > 100) {
      setValue(100);
      onChange(100);
    } else {
      onChange(value);
    }
  };

  useUpdateEffect(() => {
    setValue(defaultValue);
  }, [defaultValue, init]);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">볼륨 설정</Typography>
        <Grid container columnSpacing={2} sx={{ mt: 1 }}>
          <Grid item xs={10}>
            <Stack spacing={2} direction="row" alignItems="center">
              <VolumeDown />
              <Slider
                aria-label="Volume"
                color="secondary"
                step={step}
                min={min}
                max={max}
                value={value}
                onChange={handleSliderChange}
                onMouseUp={handleMouseUp}
                sx={{ width: '100%' }}
              />
            </Stack>
          </Grid>
          <Grid item xs={2}>
            <Input
              value={value}
              size="small"
              onChange={handleInputChange}
              onBlur={handleBlur}
              inputProps={{
                step: 10,
                min: 0,
                max: 100,
                type: 'number',
                'aria-labelledby': 'input-slider',
              }}
              readOnly={readOnly}
              sx={{ padding: '0 4px' }}
              fullWidth
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SliderInputForm;
